export const projectData = [
    {
        project: "Umzüge und Transporte ",
        imageUrl: "/images/trucks.jpeg",
        description: "Wir bringen Ihr Hab & Gut zuverlässig von A nach B.",
        
    },
    {
        project: "Sperrmüll Abholung",
        imageUrl: "/images/street-before.jpg",
        description: "Wir holen Ihren Sperrmüll zuverlässig ab und entsorgen alles fachgerecht.",
        pointsArray: [
            "Flexible Termine",
            "Faire Festpreise",
            "Umweltgerechte Entsorgung"
        ]
    },
    {
        project: "Messie-Wohnung entrümpeln",
        imageUrl: "/images/messy-room-before.jpg",
        description: "Wir räumen komplett auf, entsorgen fachgerecht und schaffen wieder Platz zum Durchatmen.",
        pointsArray: [
            "Schnelle und diskrete Einsatzteams",
            "Tiefenreinigung auf Wunsch",
            "Faire Festpreise"
        ]
    },
    {
        project: "Komplette Haushaltsauflösung",
        imageUrl: "/images/room1.webp",
        description: "Wir übernehmen das gesamte Ausräumen, Sortieren und Entsorgen für Sie",
        pointsArray: [
            "Diskret & zuverlässig",
            "Faire Festpreise",
            "Schnelle Terminvergabe"
        ]
    },
    {
        project: "Kellerentrümpelung",
        imageUrl: "/images/kel-before.jpg",
        description: "Wir räumen Ihren Keller gründlich aus und entsorgen alles fachgerecht.",
        pointsArray: [
            "Zeitnahe Termine",
            "Zuverlässiges Team",
            "Faire Festpreise"
        ]
    },
    {
        project: "Courierdienst",
        imageUrl: "/images/courier-before.jpg",
        description: "Wir liefern Ihre Sendungen direkt, sicher und ohne Umwege.",
        pointsArray: [
            "Expresszustellung",
            "Echtzeit-Kommunikation",
            "Faire Preise & Top-Service"
        ]
    }
]